import * as React from 'react';
import { AttendanceResponseDTO } from '../../../ApiOld/ApiServerVov';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';
import TimeFromMinutes from '../../Shared/Functions/TimeFromMinutes';
import { Close, Info } from '@mui/icons-material';

export interface IMobileAttendanceDetailProps {
    data: AttendanceResponseDTO;
    open: boolean;
    onClose: () => void;
}

export default function MobileAttendanceDetail(props: IMobileAttendanceDetailProps) {
    const { data, open, onClose } = props;
    const { t, i18n } = useTranslation();

    const formatDate = (date: Date | undefined) => {
        if (!date) return '';

        // Get day abbreviation in current language
        const dayAbbr = date.toLocaleDateString(i18n.language, { weekday: 'short' });

        // Format the numeric part as DD.MM.YYYY
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        return `${dayAbbr} ${day}.${month}.${year}`;
    };

    return (
        <Dialog open={open} onClose={onClose} fullScreen
            PaperProps={{
                style: { backgroundColor: '#ededed' }
            }}>
            <DialogTitle display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ background: '#ededed', padding: '10px' }}>
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ width: '100%' }}>
                    <Typography variant='h4' fontWeight={'bold'}>{t('detail')}</Typography>
                    <IconButton onClick={onClose} sx={{ color: 'black' }}>
                        <Close fontSize='large' />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box>
                    {data && <Box sx={{ background: 'white', p: 0, boxShadow: 3, borderRadius: '10px', width: '100%' }} alignItems={'center'}>
                        <Typography p={3} variant='h6' fontWeight={'bold'} justifyContent={'center'}>{formatDate(data.date)}</Typography>
                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} p={2}>
                            <Typography fontWeight={'bold'}>{t('diary.hoursHeadings')}</Typography>
                            <Typography variant='h6' color={"gray"}>{TimeFromMinutes(data.minutes ?? 0) + 'h'}</Typography>
                        </Stack>
                        <hr />
                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} p={2} pb={2}>
                            <Typography fontWeight={'bold'}>{t('deposit')}</Typography>
                            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                <Typography variant='h6' color={"gray"}>{data.deposit}</Typography>
                                <Typography variant='h6' color={"gray"}>{'Kč'}</Typography>
                            </Stack>
                        </Stack>
                    </Box>}
                    <Typography p={2} variant='body1' justifyContent={'center'}>{t('workedHoursEditReason')}</Typography>
                    {data && <Typography p={2} pl={4} variant='body2' justifyContent={'center'} mb={1}>{data.note}</Typography>}
                    <Typography p={2} variant='body1' justifyContent={'center'}>{t('depositEditReason')}</Typography>
                    {data && <Typography p={2} pl={4} variant='body2' justifyContent={'center'} mb={1}>{data.depositNote}</Typography>}
                </Box>
            </DialogContent>
            <DialogActions>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '10px' }}>
                    <Button variant="contained" color="primary" onClick={() => { onClose(); }}>
                        {t('close')}
                    </Button>
                </Box>
            </DialogActions>
        </Dialog >);
}
